exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sfc-dfp-long div span aside{background:#000}.sfc-dfp-long div span aside div[id^=google_ads_iframe_]{height:auto!important}", ""]);

